module.exports = __webpack_public_path__ + "media/images/common/add_mycatalog_off-348050623d51968ba8d94d7c303afad8.png";